import {
    open,
    closeAll
} from '../utils/helpers';

export default (editor, pfx) => {
    const $ = editor.$;
    let primaryEl = '';
    //['SEO', 'Meta Data', 'My Account', 'Billing']
    ['Give Feedback' /*, 'Report Bug'*/ ].forEach(filter => {
        primaryEl += `<div data-filter="${filter}">${filter}</div>`
    })
    const settingsEl = $(`<div id="${pfx}pn-settings-container" class="${pfx}fadein">
        <div id="${pfx}pn-settings-primary">${primaryEl}</div>
        <div class="${pfx}pn-content" style="width: 400px;">
            <div class="${pfx}pn-content-header" data-category="/Give Feedback"></div>
            <div id="feedback-panel-container"></div>
        </div>
    </div>`);
    const primaryFiltersObject = settingsEl.find(`#${pfx}pn-settings-primary div`);
    const content = settingsEl.find(`.${pfx}pn-content`);

    primaryFiltersObject.get(0).setAttribute('data-active', true);

    primaryFiltersObject.on('click', function (e) {
        if (this.getAttribute('data-active') !== 'true') {
            const query = this.getAttribute('data-filter');
            closeAll(primaryFiltersObject);
            open(this);
            content.children().get(0).setAttribute('data-category', query === 'Give Feedback' ? '/Give Feedback' : 'Bug');
        }
    });

    return settingsEl;
}